import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";
import { addFeatureList } from "../../../api/service/custompage.service";

const AddFeatures = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    page_id: id || "",
    name: "",
    description: "",
  });

  const [images, setImages] = useState([]);

  const slugFromUrl = window.location.pathname.split("/").pop();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (id) {
      setFormData((prev) => ({ ...prev, page_id: id }));
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileSelect = (file) => {
    const preview = URL.createObjectURL(file);

    setImages((prev) => [
      ...prev,
      {
        file,
        preview,
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      showToast.error("Please enter feature name");
      return;
    }

    if (!formData.description.trim()) {
      showToast.error("Please enter feature description");
      return;
    }

    if (!formData.page_id) {
      showToast.error("Page ID is missing");
      return;
    }

    if (images.length === 0) {
      showToast.error("Please upload feature icon");
      return;
    }

    try {
      setLoading(true);

      const submitData = new FormData();
      submitData.append("page_id", formData.page_id);
      submitData.append("name", formData.name.trim());
      submitData.append("description", formData.description.trim());
      submitData.append("icon", images[0].file);

    
      submitData.append("slug", slugFromUrl);

      const response = await addFeatureList(submitData);

      if (response.success) {
        showToast.success(response.message || "Feature added successfully!");
        navigate(-1);
      } else {
        showToast.error(response.message || "Failed to add feature");
      }
    } catch (error) {
      console.error("Add Feature Error:", error);
      showToast.error(error?.response?.data?.message || "Failed to add feature");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="management-tile mb-0">Add Feature</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="mb-3">
            <label className="form-label">
              Feature Name <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              name="name"
              value={formData.name}
              placeholder="Enter feature name (e.g., Premium Quality)"
              onChange={handleInputChange}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Description <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              type="textarea"
              name="description"
              value={formData.description}
              placeholder="Enter feature description"
              onChange={handleInputChange}
              rows={4}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Icon <span style={{ color: "red" }}>*</span>
            </label>

            <UploadImage onFileSelect={handleFileSelect} />
          </Col>

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Adding..." : "Add Feature"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default AddFeatures;
